<script setup>
// NOTICE: KAPTION-INTEGRATION
// sales-pipeline.DRAG.1 — the draggable card list shared by board columns and
// swimlane cells. It never mutates its items: a drop is reported upward and the
// board's state (optimistic move/reassign) re-renders the lists.

import draggable from 'vuedraggable';
import KaptionSalesPipelineCard from './KaptionSalesPipelineCard.vue';

const props = defineProps({
  items: { type: Array, default: () => [] },
  stage: { type: Object, required: true },
  stages: { type: Array, default: () => [] },
  laneId: { type: String, default: '' },
  moveGuard: { type: Function, default: () => true },
  nowSeconds: { type: Number, default: 0 },
  focusedId: { type: [Number, String], default: null },
  minHeightClass: { type: String, default: 'min-h-[3rem]' },
  condensed: { type: Boolean, default: false },
});

const emit = defineEmits(['drop', 'open', 'dragStart', 'dragEnd']);

function onChange(evt) {
  if (evt.added) {
    emit('drop', {
      conversation: evt.added.element,
      toStageId: props.stage.id,
      toLaneId: props.laneId || null,
    });
  }
}
</script>

<template>
  <draggable
    :model-value="items"
    item-key="id"
    :group="{ name: 'kaption-pipeline' }"
    :sort="false"
    :animation="150"
    :move="moveGuard"
    force-fallback
    :fallback-tolerance="4"
    ghost-class="sortable-ghost"
    drag-class="sortable-drag"
    class="flex flex-col"
    :class="[minHeightClass, condensed ? 'gap-1' : 'gap-1.5']"
    :component-data="{
      'data-stage-id': stage.id,
      'data-lane-id': laneId || undefined,
      'data-testid': 'pipeline-drop-list',
    }"
    @change="onChange"
    @start="emit('dragStart', $event)"
    @end="emit('dragEnd', $event)"
  >
    <template #item="{ element }">
      <KaptionSalesPipelineCard
        :conversation="element"
        :stages="stages"
        :stage-color="stage.color"
        :now-seconds="nowSeconds"
        :focused="focusedId === element.id"
        :condensed="condensed"
        @open="emit('open', $event)"
      />
    </template>
  </draggable>
</template>
